export interface INavbarItem {
  name: string;
  icon?: string;
  routerLink: string | string[];
  queryParams?: string;
}
